import { Box, VStack } from '@chakra-ui/react';
import { Navigate, Outlet } from 'react-router';
import { SIDEBAR_WIDTH_COLLAPSED } from '~/apps/consumer/components/PageDetailLayout/SidebarItem';
import { CenterSpinner } from '~/common/components/CenterSpinner';
import { useProdFeatureFlagEnabled } from '~/common/hooks/useProdFeatureFlagEnabled';
import { useAppContext } from '~/services/main/contexts/AppContext';
import { PartnersSection } from './components/PartnersSection/PartnersSection';
import { TabNavigation } from './components/TabNavigation';
import { NotificationsContextProvider } from './context/NotificationsContext';

export const OrganizationNotificationsPage = () => {
  const {
    selectedOrganization,
    loadingOrganizations,
    loadingIsSelectedOrgAdmin,
    isSelectedOrgAdmin,
  } = useAppContext();

  const isEssentialsEnabled = useProdFeatureFlagEnabled('essentials-product');

  if (loadingOrganizations || loadingIsSelectedOrgAdmin) {
    return <CenterSpinner />;
  }

  if (!isEssentialsEnabled || !selectedOrganization || !isSelectedOrgAdmin) {
    return <Navigate replace to="/" />;
  }

  return (
    <NotificationsContextProvider>
      <VStack
        alignItems="stretch"
        maxWidth="1800px"
        minHeight="100dvh"
        pr={0}
        py={{ base: 4, md: 6, lg: 8 }}
        spacing={0}
        width={`calc(100dvw - ${SIDEBAR_WIDTH_COLLAPSED})`}
      >
        <Box pl={{ base: 0, md: 6, lg: 12 }}>
          <PartnersSection />
          <TabNavigation />
        </Box>

        <Box flex={1} position="relative">
          <Outlet />
        </Box>
      </VStack>
    </NotificationsContextProvider>
  );
};
